import { Theme } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export const GlobalCss = withStyles((theme: Theme) => ({
  '@global': {
    /* Helper */
    '.fw-500': {
      fontWeight: 500,
    },
    '.textCenter': {
      textAlign: 'center',
    },

    /* Margin */
    '.mt2': {
      marginTop: '2rem',
    },
    '.mt3': {
      marginTop: '3rem',
    },
    '.mb05': {
      marginBottom: '0.5rem',
    },
    '.mb1': {
      marginBottom: '1rem',
    },
    '.mb2': {
      marginBottom: '2rem',
    },
    '.my1': {
      marginTop: '1rem',
      marginBottom: '1rem',
    },
    '.my2': {
      marginTop: '2rem',
      marginBottom: '2rem',
    },
    '.my3': {
      marginTop: '3rem',
      marginBottom: '3rem',
    },

    /* Padding */
    '.pt1': {
      paddingTop: '1rem',
    },
    '.pt2': {
      paddingTop: '2rem',
    },
    '.pt3': {
      paddingTop: '3rem',
    },
    '.pb1': {
      paddingBottom: '1rem',
    },
    '.pb2': {
      paddingBottom: '2rem',
    },
    '.pb3': {
      paddingBottom: '3rem'
    },
    '.py1': {
      paddingTop: '1rem',
      paddingBottom: '1rem',
    },

    '.lead1': theme.leads.lead1,
    '.lead2': theme.leads.lead2,
    '.overline1': theme.overlines.overline1,
    '.overline2': theme.overlines.overline2,

    'textUnderline': {
      textDecoration: 'underline',
    },

    '.inputLabel': {
      marginBottom: '0.5rem',
      ...theme.form.labels.inputField.label,
    },
    '.fieldError': {
      ...theme.form.labels.selectFieldSmall.hint,
      color: theme.palette.utility.redDark,
      fontWeight: 500,
      lineHeight: '2.25rem',
    },
  },
}))(() => null);

export default GlobalCss;
